/*
 * LSJ Regal — Infinite Scroll for collection pages.
 *
 * Looks for a paginated grid annotated with:
 *   <div data-infinite-grid>...</div>
 *   <a data-infinite-next href="/collections/dresses?page=2"></a>
 *
 * As the sentinel scrolls into view, the next page is fetched, its product
 * cards are extracted from the same selector and appended to the grid, and
 * the "next" link is updated. Stops when there is no next page.
 *
 * Falls back gracefully: if IntersectionObserver is missing, or if the user
 * clicks the standard "Load more" button, the same loader runs.
 */
(function () {
  'use strict';

  var GRID_SELECTOR = '[data-infinite-grid]';
  var NEXT_SELECTOR = '[data-infinite-next]';
  var ITEM_SELECTOR = '.product-card';
  var LOAD_BTN_SEL  = '[data-infinite-load]';
  var SENTINEL_CLS  = 'infinite-sentinel';
  var STATUS_CLS    = 'infinite-status';

  var grid     = document.querySelector(GRID_SELECTOR);
  var nextLink = document.querySelector(NEXT_SELECTOR);
  if (!grid) return;

  // Inject sentinel + status nodes once.
  var sentinel = document.createElement('div');
  sentinel.className = SENTINEL_CLS;
  sentinel.setAttribute('aria-hidden', 'true');

  var status = document.createElement('p');
  status.className = STATUS_CLS;
  status.setAttribute('role', 'status');
  status.setAttribute('aria-live', 'polite');
  status.textContent = '';

  grid.parentNode.insertBefore(sentinel, grid.nextSibling);
  grid.parentNode.insertBefore(status, sentinel.nextSibling);

  // Inline styles (kept tiny so the asset is drop-in).
  var style = document.createElement('style');
  style.textContent = ''
    + '.' + SENTINEL_CLS + '{height:1px;margin-top:80px}'
    + '.' + STATUS_CLS   + '{text-align:center;color:var(--muted,#777);font-size:.7rem;'
    +                        'letter-spacing:.3em;text-transform:uppercase;padding:24px 0}'
    + '.infinite-loading .product-card{animation:infFade .6s ease both}'
    + '@keyframes infFade{from{opacity:0;transform:translateY(14px)}to{opacity:1;transform:none}}';
  document.head.appendChild(style);

  var loading = false;
  var done    = !nextLink;

  function setStatus(msg){ status.textContent = msg || ''; }

  function setNext(href){
    if (!href) {
      done = true;
      if (nextLink && nextLink.parentNode) nextLink.parentNode.removeChild(nextLink);
      var loadBtn = document.querySelector(LOAD_BTN_SEL);
      if (loadBtn) loadBtn.style.display = 'none';
      setStatus('You have reached the end of the edit.');
      return;
    }
    if (!nextLink) {
      nextLink = document.createElement('a');
      nextLink.setAttribute('data-infinite-next', '');
      nextLink.hidden = true;
      grid.parentNode.appendChild(nextLink);
    }
    nextLink.href = href;
  }

  function loadNext() {
    if (loading || done || !nextLink) return;
    loading = true;
    setStatus('Loading more pieces…');

    var url = nextLink.href;
    fetch(url, { headers: { Accept: 'text/html' }, credentials: 'same-origin' })
      .then(function (res) {
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newGrid = doc.querySelector(GRID_SELECTOR);
        var newNext = doc.querySelector(NEXT_SELECTOR);

        if (!newGrid) {
          setNext(null);
          return;
        }

        var items = newGrid.querySelectorAll(ITEM_SELECTOR);
        if (!items.length) {
          setNext(null);
          return;
        }

        grid.classList.add('infinite-loading');
        var frag = document.createDocumentFragment();
        items.forEach(function (item) { frag.appendChild(document.importNode(item, true)); });
        grid.appendChild(frag);

        // Update browser URL so reload preserves the scroll position.
        if (window.history && window.history.replaceState) {
          try { window.history.replaceState({}, '', url); } catch (e) {}
        }

        setNext(newNext ? newNext.href : null);
        setStatus(done ? 'You have reached the end of the edit.' : '');

        // Let pages re-bind to newly-appended cards if they need to.
        document.dispatchEvent(new CustomEvent('infinite:appended', {
          detail: { count: items.length, container: grid, url: url }
        }));
      })
      .catch(function () {
        setStatus('Could not load more — please try again.');
      })
      .finally(function () {
        loading = false;
        // Re-observe in case the sentinel is already visible.
        if (observer && !done) observer.observe(sentinel);
      });
  }

  var observer = null;
  if ('IntersectionObserver' in window) {
    observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) loadNext();
      });
    }, { rootMargin: '600px 0px' });
    observer.observe(sentinel);
  }

  // Manual button fallback / additional trigger.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest(LOAD_BTN_SEL);
    if (btn) { e.preventDefault(); loadNext(); }
  });
})();
